module.exports = __webpack_public_path__ + "img/user.1859600c.svg";